import React, { useState, useEffect, useMemo } from 'react';
import { Space, ConfigProvider } from 'antd';
import { DeleteTemplateEmail, GetAllTemplatesEmails } from '@services/TemplateEmail/Index.jsx';
import { CustomLoader } from '@components/UI/CustomLoader/Index.jsx';
import { DeleteOptionComp } from '@components/UI/DeleteOption/Index.jsx';
import { EditOptionComp } from '@components/UI/EditOption/Index.jsx';
import TipoEmail from "@components/UI/TipoEmail/Index.jsx";
import { StyledTable } from '@styles/datatables/datatable-antd.js';
import ptBR from 'antd/es/locale/pt_BR';
import TextBlock from '@components/UI/TextBlock/Index..jsx';

const GridTemplateEmail = ({ state, setData, openModal, setSelectedRow, onDelete, filters }) => {
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const apiFilters = useMemo(() => ({
    nome: filters.nome || "",
    tipoEmail: filters.tipoEmail || "",
  }), [filters]);

  const fetchData = async (currentPage, currentRowsPerPage, apiFilters = {}) => {
    setLoading(true);
    try {
      const response = await GetAllTemplatesEmails(currentPage, currentRowsPerPage, apiFilters);
      setData(response.items, response.totalItems);
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(page, rowsPerPage, apiFilters);
  }, [page, rowsPerPage, apiFilters]);

  const handlePageChange = (newPage, newRowsPerPage) => {
    setPage(newPage);
    setRowsPerPage(newRowsPerPage);
  };

  const columns = [
    {
      title: 'NOME',
      dataIndex: 'nome',
      key: 'nome',
      sorter: (a, b) => a.nome.localeCompare(b.nome),
      width: '10%',
      render: (text, record) => (
        <TextBlock>
          {text}
        </TextBlock>
      ),
    },
    {
      title: 'TÍTULO',
      dataIndex: 'titulo',
      key: 'titulo',
      sorter: (a, b) => a.titulo.localeCompare(b.titulo),
      width: '10%',
      render: (text, record) => (
        <TextBlock>
          {text}
        </TextBlock>
      ),
    },
    {
      title: 'TIPO E-MAIL',
      dataIndex: 'tipoEmail',
      key: 'tipoEmail',
      render: (tipoEmail) => <TipoEmail tipoEmail={tipoEmail} />,
      width: '10%',
    },
    // {
    //   title: 'CONTEÚDO',
    //   dataIndex: 'conteudo',
    //   key: 'conteudo',
    //   width: '15%',
    //   sorter: (a, b) => a.conteudo.localeCompare(b.conteudo),
    //   render: (text, record) => (
    //     <TextBlock>
    //       {text}
    //     </TextBlock>
    //   ),
    // },
    {
      title: 'AÇÕES',
      key: 'actions',
      width: '5%',
      render: (text, row) => (
        <Space size="middle">
          <EditOptionComp
            row={row}
            setSelectedRow={setSelectedRow}
            openModal={openModal}
          />
          <DeleteOptionComp
            row={row}
            deleteFunction={DeleteTemplateEmail}
            onDelete={onDelete}
            itemNameKey={"nome"}
          />
        </Space>
      ),
    },
  ];

  return (
    <div className='px-4'>
      <div className='mt-3 mb-3'>
        <h1>Lista de Templates de E-mails Registrados</h1>
      </div>

      <ConfigProvider locale={ptBR}>
        <StyledTable
          rowKey={"id"}
          columns={columns}
          dataSource={state.data}
          loading={{
            spinning: loading,
            indicator: <CustomLoader />,
          }}
          pagination={{
            current: page,
            pageSize: rowsPerPage,
            total: state.totalRows,
            onChange: handlePageChange,
            showSizeChanger: true,
            onShowSizeChange: handlePageChange,
            showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`,
          }}
          scroll={{ y: '20rem' }}
          locale={{ emptyText: <h2 className='m-3'>Nenhum registro disponível para exibição.</h2> }}
        />
      </ConfigProvider>
    </div>
  );
};

export default GridTemplateEmail;
